export default __webpack_public_path__ + "static/media/tag.303aa8fc.png";